module.exports = {
  STATES_LABELS: {
    irrigating: 'Regando',
    moving: 'Moviendo equipo',
    off: 'Apagado',
    failure: 'Equipo en falla'
  },
  STATES: {
    IRRIGATING: 'irrigating',
    MOVING: 'moving',
    OFF: 'off',
    FAILURE: 'failure'
  },
  COLOR: {
    WHITE: '#FFFFFF',
    BLACK: '#000000',
    RED: '#ED1F24',
    GREEN: '#00d166',
    GREY: '#999',
    BLUE: '#4F5AB0'
  }
};



// WEBPACK FOOTER //
// ./src/constants/constants.js